// extracted by mini-css-extract-plugin
export default {"anchor":"truncated-cell-tooltip_anchor__Wbxdu","portal":"truncated-cell-tooltip_portal__35OTl"};